import { useContext } from 'react';
import { NotebooksContext } from '../Context/Notebooks/index.js';

const useNotebooks = () => {
  const context = useContext(NotebooksContext);

  if (!context) {
    throw new Error('useNotebooks must be within a NotebooksContextProvider');
  }

  return context;
};

export default useNotebooks;
